import React, { useCallback, useEffect, useState } from 'react';
import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { CollapseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getBreakpoint, isFunction } from '@philips-internal/oswald-ui-utils';
import { CollapseArrow } from '../../collapse-arrow/collapse-arrow.js';
import { getDynamicContent, getFormattedDate, getGroupedData, getTimelineWidth } from '../timeline-utils.js';
import { TimelineEvents } from './timeline-events.js';
import './timeline-group.css';
const isMobile = () => {
    const breakpoint = getBreakpoint();
    return breakpoint === Breakpoint.XSM;
};
function TimelineGroup(props) {
    const { data, groupBy, groupedByTime, groupKey, interval, intervals, onClick, onCollapse, onContextMenuClick, onDoubleClick, onDynamicContentRender, superscription, superscriptionEntry, ungroupedTitle } = props;
    const [collapsed, setCollapsed] = useState(false);
    useEffect(() => {
        if (isFunction(onCollapse)) {
            onCollapse(new CollapseEvent({ collapsed }));
        }
    }, [collapsed]);
    const onCollapseArrowClick = useCallback(() => {
        setCollapsed((collapsed) => !collapsed);
    }, []);
    const header = (React.createElement("div", { className: "c-timeline-group__header-info" }, getDynamicContent({ data, entry: groupKey, onDynamicContentRender, type: 'groupHeader', value: groupKey })));
    const headerTime = () => {
        const { date, time } = getFormattedDate(groupKey);
        return (React.createElement("div", { className: "c-timeline-group__header-time" },
            React.createElement("div", { className: "c-timeline-group__header-time__infos" },
                React.createElement("span", { className: "c-timeline-group__header-time__text" }, time || MessageService.translate(ungroupedTitle)),
                React.createElement("span", { className: "c-timeline-group__header-time__text" }, MessageService.translate(date))),
            React.createElement(CollapseArrow, { collapsed: collapsed, onClick: onCollapseArrowClick })));
    };
    const renderEvents = (React.createElement(TimelineEvents, { data: data, interval: interval, intervals: intervals, onClick: onClick, onContextMenuClick: onContextMenuClick, onDoubleClick: onDoubleClick, onDynamicContentRender: onDynamicContentRender, superscription: superscription, superscriptionEntry: superscriptionEntry }));
    const renderSubgroups = (data) => {
        return Object.entries(data).map(([groupKey, item]) => {
            return (React.createElement(TimelineGroup, { data: item, groupBy: groupBy, groupKey: groupKey, groupedByTime: false, interval: interval, intervals: intervals, key: groupKey, onClick: onClick, onContextMenuClick: onContextMenuClick, onDoubleClick: onDoubleClick, onDynamicContentRender: onDynamicContentRender, superscription: superscription, superscriptionEntry: superscriptionEntry, ungroupedTitle: ungroupedTitle }));
        });
    };
    const renderGroupedTime = () => {
        const groupedData = groupBy && getGroupedData(data, groupBy);
        const events = collapsed
            ? null
            : groupedData
                ? renderSubgroups(groupedData)
                : renderEvents;
        return (React.createElement("div", { className: "c-timeline-group" },
            headerTime(),
            events));
    };
    const renderGrouped = () => {
        const width = isMobile() ? undefined : `${getTimelineWidth(intervals.length)}rem`;
        return (React.createElement("div", { className: "c-timeline-group", style: { width: width } },
            header,
            !collapsed ? renderEvents : null));
    };
    return (groupedByTime ? renderGroupedTime() : renderGrouped());
}
export { TimelineGroup, };
//# sourceMappingURL=timeline-group.js.map